import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-news",
  "use": "icon-news-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-news\"><defs><style type=\"text/css\"></style></defs><path d=\"M963.584 0q24.576 0 42.496 17.408t17.92 43.008l0 692.224q0 8.192-17.92 31.232t-45.056 53.248-60.416 63.488-63.488 60.416-53.248 45.056-31.232 17.92l-692.224 0q-24.576 0-42.496-17.92t-17.92-42.496l0-903.168q0-25.6 17.92-43.008t42.496-17.408l903.168 0zM649.216 812.032q13.312 0 22.528-9.728t9.216-23.04-9.216-22.528-22.528-9.216l-486.4 0q-13.312 0-23.04 9.216t-9.728 22.528 9.728 23.04 23.04 9.728l486.4 0zM909.312 551.936q14.336 0 23.552-9.728t9.216-24.064q0-12.288-9.216-21.504t-23.552-9.216l-746.496 0q-13.312 0-23.04 9.216t-9.728 21.504q0 14.336 9.728 24.064t23.04 9.728l746.496 0zM909.312 325.632q14.336 0 23.552-9.728t9.216-24.064q0-13.312-9.216-22.528t-23.552-9.216l-746.496 0q-13.312 0-23.04 9.216t-9.728 22.528q0 14.336 9.728 24.064t23.04 9.728l746.496 0z\" p-id=\"1405\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/news.svg
// module id = zgXw
// module chunks = 104